
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hozhizxprvoawkpyhgcn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhvemhpenhwcnZvYXdrcHloZ2NuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE3MjYzMzYsImV4cCI6MjA1NzMwMjMzNn0.BmYGIt-slzGSX0F4ILmH1gRrdim59FgdUm-xq_OLiqA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Helper to get the API URL for Edge Functions
export const getEdgeFunctionUrl = (functionName: string) => {
  const isLocalDev = import.meta.env.DEV;
  const baseUrl = isLocalDev 
    ? "http://localhost:54321" 
    : SUPABASE_URL;
  return `${baseUrl}/functions/v1/${functionName}`;
};
